import { Controller } from '@hotwired/stimulus';

// Safari iOS refuses Onfido's motion capture when the widget's iframe lacks the
// motion sensors in its allow policy, so we complete it as soon as the widget
// inserts the iframe (see Lemonway widget update of 2025-10-05, Onfido SDK 14.87.0).
const IFRAME_ALLOW_POLICY = [
  'camera *',
  'microphone *',
  'geolocation *',
  'clipboard-read *',
  'clipboard-write *',
  'gyroscope *',
  'accelerometer *',
  'magnetometer *',
  'ch-ua-platform-version *',
  'ch-ua-model *',
  'ch-ua-full-version *',
].join('; ');

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String
  };

  connect() {
    this.#patchWidgetIframePermissions();
    this.initWidget();
  }

  disconnect() {
    this.iframePermissionsObserver?.disconnect();
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: 'fr',
        onMyAccount: () => this.redirectToNextStep(false),
        onFinish: () => this.redirectToNextStep(true),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: 'smooth',
        }),
      },
    );
  }

  redirectToNextStep(success = false) {
    const url = new URL(this.redirectUrlValue);

    if (success) {
      url.searchParams.set('success', 'under_analysis');
    }

    window.location.replace(url);
  }

  // The widget inserts its iframe asynchronously, so we watch the container and
  // patch the iframe on insertion: completing `allow` alone is not enough, the
  // permission policy is frozen at load, so we rewrite `src` to reload it.
  #patchWidgetIframePermissions() {
    this.iframePermissionsObserver = new MutationObserver(() => {
      const iframe = this.element.querySelector('iframe');
      if (!iframe) return;

      this.iframePermissionsObserver.disconnect();
      iframe.setAttribute('allow', IFRAME_ALLOW_POLICY);
      iframe.setAttribute('src', iframe.getAttribute('src'));
    });

    this.iframePermissionsObserver.observe(this.element, { childList: true });
  }
}
